import img from '../../../../../assets/images/textEditorToolBarIcons/Bold.svg';
export const BoldButton = img;
